// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";

const firebaseConfig = {
  apiKey: "AIzaSyAKxGmfn9hEcMCVP4_1QOjveckhuBDrF1U",
  authDomain: "prmconnect-465c2.firebaseapp.com",
  projectId: "prmconnect-465c2",
  storageBucket: "prmconnect-465c2.appspot.com",
  messagingSenderId: "124466533543",
  appId: "1:124466533543:web:90b524a293d8ffa347f782",
  measurementId: "G-CQ056JR6TV"
};

// Initialize Firebase
const fire = initializeApp(firebaseConfig);
export default fire;
